export const resolveAvatarSrc = (avatarPath: string): string => {
  if (!avatarPath) return '/assets/avatar/characters/Buddy.png'
  if (avatarPath.includes('/avatar/characters/')) return avatarPath
  if (avatarPath.includes('eye')) return '/assets/avatar/characters/Explorer.png'
  if (avatarPath.includes('rabbit')) return '/assets/avatar/characters/Buddy.png'
  if (avatarPath.includes('smart')) return '/assets/avatar/characters/Thinker.png'
  return '/assets/avatar/characters/Buddy.png'
}
